<div class="content-block">

     <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Dashboard Dipendente </h2>
                <div class="d-flex gap-2">
                   <dx-button stylingMode="contained" class="mr-3" text="Modifica dipendente" icon="edit" type="success" (onClick)="goToDipendenteEdit()"> </dx-button>
                  <dx-button stylingMode="outlined" text="Nuova consegna articolo" icon="plus" type="normal" (onClick)="goToNuovaconsegna()"> </dx-button>
                  
                </div>
            </div>
        </div>
      </div>

  <!-- Profilo + contatori-->
<div class="row g-3 mb-3">
      <div class="col-12 col-lg-4">
        <div class="card p-4 h-80 shadow-sm border-0">
          <div class="d-flex align-items-center">
          
            <div class="flex-grow-1">
              <h2 class="card-title mb-3" style="margin-top:0">
                {{dipendente?.nominativo}}
                @if(dipendente){
                <span id="empStatusBadge" class="badge ms-2" 
                [style.background-color]="dipendente?.attivo ? '#28a745' : '#dc3545'"
                      style="margin-left:10px;  color: #fff;">
                  {{dipendente?.attivo ? 'Attivo' : 'Non attivo'}}
                </span>
              }
              </h2>
              
            </div>
          </div>

          <dl class="row mb-0">
            <dt class="col-3 col-md-3 fw-semibold">Codice:</dt>
              <dd class="col-9 col-md-9">{{dipendente?.codice}}</dd> 
            <dt class="col-3 col-md-3 fw-semibold">Reparto:</dt>
              <dd class="col-9 col-md-9">{{repartoDescrizione}}</dd>
              <dt class="col-3 col-md-3 fw-semibold">Responsabile:</dt>
              <dd class="col-9 col-md-9">{{responsabileNominativo}}  </dd>
              <dt class="col-3 col-md-3 fw-semibold">Mansione:</dt>
              <dd class="col-9 col-md-9">{{mansioneDescrizione}}</dd>
          </dl>
          
        </div>

      </div>

      <div class="col-12 col-lg-8">
        <div class="row g-3">
          <div class="col-6 col-md-4">
            <div class="card p-3 text-center border-4" style="border-width: 3px;min-height: 200px; overflow:auto;">
              <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Articoli assegnati</h2>

              <div  class="big-number">{{numDpiAssegnati}}</div>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="card p-3 text-center border-4" style="border-width: 3px;min-height: 200px; overflow:auto;" [class]="{'border-warning':numConsegneProssimeAllaScadenza > 0, 'border-normal': numConsegneProssimeAllaScadenza <= 0}">
             <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Articoli in scadenza</h2>
              <div  class="big-number" [class]="{'text-warning' : numConsegneProssimeAllaScadenza > 0, 'text-muted': numConsegneProssimeAllaScadenza <= 0}">{{numConsegneProssimeAllaScadenza}}</div>
              <div class="mini text-muted"> entro {{giorniPreAlertArticoli}}gg</div>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="card p-3 text-center border-4" style="border-width: 3px;min-height: 200px; overflow:auto;"  [class]="{'border-danger': numConsegneScadute > 0, 'border-normal': numConsegneScadute <= 0}">
              <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.8em;">Articoli scaduti</h2>
              <div class="big-number" [class]="{'text-danger' :numConsegneScadute > 0, 'text-muted': numConsegneScadute <= 0}">{{numConsegneScadute}}</div>
               <div class="mini text-muted"> articoli scaduti</div>
            </div>
          </div>

        </div>
      </div>
    </div>

<!-- Charts -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-lg-4">
        <div class="card p-3">
          <h3 class="card-title font-weight-bold">Distribuzione per categoria</h3>
          <app-chart-pie-tipologie [idDipendente]="idDipendente"></app-chart-pie-tipologie>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card p-3">
          <h3 class="card-title font-weight-bold">Ultimi articoli consegnati</h3>
           <div class="table-responsive" style="max-height:680px; overflow:auto;">
              <app-grid-consegne-compact [idDipendente]="idDipendente"></app-grid-consegne-compact>
            </div>
        </div>
  
      </div>
       <div class="col-12 col-lg-4">
        <div class="card p-3">
          <h3 class="card-title mb-3 font-weight-bold">Articoli prossimi alla scadenza o scaduti</h3>
          <div class="table-responsive" style="min-height: 150px; overflow:auto;">
            <app-articoli-consegnati-scadenze-compact [listConsegneAlert]="listConsegneAlert" [idDipendente]="idDipendente"></app-articoli-consegnati-scadenze-compact>
          </div>
        </div>

        <div class="card p-3">
          <h3 class="card-title mb-3 font-weight-bold">Scadenze dipendente</h3>
          <div class="table-responsive"  style="min-height: 150px; overflow:auto;">
            <app-grid-scadenze-dipendenti-compact [idDipendente]="idDipendente"></app-grid-scadenze-dipendenti-compact>
          </div>
        </div>

      
    </div>


    <!-- Consegne prossime alla scadenza o scadute -->
     <!--
    <div class="row  mb-3">
      <div class="col-12 col-lg-4">
        <div class="card p-3">
          <h3 class="card-title mb-3 font-weight-bold">Articoli prossimi alla scadenza o scadute</h3>
          <div class="table-responsive" style="min-height: 150px; overflow:auto;">
            <app-articoli-consegnati-scadenze-compact [listConsegneAlert]="listConsegneAlert" [idDipendente]="idDipendente"></app-articoli-consegnati-scadenze-compact>
          </div>
        </div>

        <div class="card p-3">
          <h3 class="card-title mb-3 font-weight-bold">Altre scadenze</h3>
          <div class="table-responsive"  style="min-height: 150px; overflow:auto;">
            <app-grid-scadenze-dipendenti-compact [idDipendente]="idDipendente"></app-grid-scadenze-dipendenti-compact>
          </div>
        </div>
        
      </div>
      <div class="col-12 col-lg-4">
        <div class="card p-3">
          <h3 class="card-title mb-3 font-weight-bold">Altre scadenze</h3>
          <div class="table-responsive"  style="min-height: 150px; overflow:auto;">
            <app-grid-scadenze-dipendenti-compact [idDipendente]="idDipendente"></app-grid-scadenze-dipendenti-compact>
          </div>
        </div>
      </div>
    </div>
  -->


    </div>
